import { AlertIcon, CheckCircleIcon, AlertFillIcon, CheckCircleFillIcon } from '@primer/octicons-react';
import { clsx } from 'clsx';
import React from 'react';
import classes from './InlineMessage.module.css.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import Box from '../Box/Box.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const variantToIcon = variant => {
  const icons = {
    warning: /*#__PURE__*/React.createElement(AlertIcon, {
      className: classes.InlineMessageIcon
    }),
    critical: /*#__PURE__*/React.createElement(AlertIcon, {
      className: classes.InlineMessageIcon
    }),
    success: /*#__PURE__*/React.createElement(CheckCircleIcon, {
      className: classes.InlineMessageIcon
    }),
    unavailable: /*#__PURE__*/React.createElement(AlertIcon, {
      className: classes.InlineMessageIcon
    })
  };
  return icons[variant];
};
const variantToSmallIcon = variant => {
  const icons = {
    warning: /*#__PURE__*/React.createElement(AlertFillIcon, {
      className: classes.InlineMessageIcon,
      size: 12
    }),
    critical: /*#__PURE__*/React.createElement(AlertFillIcon, {
      className: classes.InlineMessageIcon,
      size: 12
    }),
    success: /*#__PURE__*/React.createElement(CheckCircleFillIcon, {
      className: classes.InlineMessageIcon,
      size: 12
    }),
    unavailable: /*#__PURE__*/React.createElement(AlertFillIcon, {
      className: classes.InlineMessageIcon,
      size: 12
    })
  };
  return icons[variant];
};
function InlineMessage({
  children,
  className,
  size = 'medium',
  variant,
  sx: sxProp = defaultSxProp,
  ...rest
}) {
  const icon = size === 'small' ? variantToSmallIcon(variant) : variantToIcon(variant);
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      sx: sxProp,
      className: clsx(className, classes.InlineMessage)
    }, rest, {
      "data-size": size,
      "data-variant": variant
    }), icon, children);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(className, classes.InlineMessage)
  }, rest, {
    "data-size": size,
    "data-variant": variant
  }), icon, children);
}
InlineMessage.displayName = "InlineMessage";

export { InlineMessage };
